import React from "react";
import { Trans, WithTranslation } from "react-i18next";

const LearnMoreLink = (props: { children?: React.ReactNode }) => (
    <a
        href="https://support.beautiful.ai/hc/en-us/articles/360000771231-How-can-I-collaborate-with-someone-"
        target="_blank"
        rel="noopener noreferrer"
    >
        {props.children}
    </a>
);

type TranslationFn = WithTranslation["t"];

type Props = {
    t: TranslationFn;
};

export function PresentationLibraryShareNoticeMessage({ t }: Props) {
    return (
        <Trans
            t={t}
            i18nKey="Maybe you should share one of yours? <br/><gdriveLink>Learn more</gdriveLink> about sharing and collaboration."
            components={{
                br: <br />,
                gdriveLink: <LearnMoreLink />
            }}
        />
    );
}
